module.exports = __webpack_public_path__ + "img/tu04.01129e7d.jpg";